import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

/**
 * Quiet banner shown on a LEFT child's parent pages (Task 17, behaviour map §2).
 *
 * A parent of a child who has left the service keeps read-only access to their
 * history — attendance, incidents, medication log, observations — but loses
 * every write (absence filing, form submit, medication consent, pickup edits).
 * This banner tells them why the actions are gone; the ability layer is what
 * actually enforces the read-only rule, never the UI.
 */
const ParentLeftChildBanner: React.FC<{ childName: string; locationName: string }> = ({
  childName,
  locationName,
}) => (
  <section
    data-testid="parent-left-child-banner"
    className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-start gap-3"
  >
    <InformationCircleIcon
      aria-hidden="true"
      className="h-5 w-5 text-gray-500 flex-shrink-0 mt-0.5"
    />
    <p className="text-sm text-gray-700">
      {childName} has left {locationName || 'this service'} — records remain available to view.
    </p>
  </section>
);

export default ParentLeftChildBanner;
